export default {
  init() {

    var $tabs = function (target) {
      var
        _elemTabs = (typeof target === 'string' ? document.querySelector(target) : target),
        _eventTabsShow,
        _showTab = function (tabsLinkTarget) {
          var tabsPaneTarget, tabsLinkActive, tabsPaneShow;
          // var tabsPaneTarget, tabsLinkActive, tabsPaneShow, notActiveTab;
          tabsPaneTarget = document.querySelector(tabsLinkTarget.getAttribute('href'));
          tabsLinkActive = tabsLinkTarget.parentElement.querySelector('.tabs__link_active');
          tabsPaneShow = tabsPaneTarget.parentElement.querySelector('.tabs__pane_show');

          // let selector = ':not([href="' + tabsLinkTarget.getAttribute('href') + '"])';
          // notActiveTab = document.querySelector(tabsLinkTarget.parentElement.querySelector(selector).getAttribute('href'));

          // если следующая вкладка равна активной, то завершаем работу
          if (tabsLinkTarget === tabsLinkActive) {
            return;
          }
          // удаляем классы у текущих активных элементов
          if (tabsLinkActive !== null) {
            tabsLinkActive.classList.remove('tabs__link_active');
          }
          if (tabsPaneShow !== null) {
            // notActiveTab.classList.add('hide');
            // notActiveTab.classList.remove('show');
            // tabsPaneTarget.classList.remove('hide');
            // tabsPaneTarget.classList.add('show');


            tabsPaneShow.classList.remove('tabs__pane_show');
          }
          // добавляем классы к элементам (в завимости от выбранной вкладки)
          tabsLinkTarget.classList.add('tabs__link_active');
          tabsPaneTarget.classList.add('tabs__pane_show');

          // рисуем подчеркивание табов
          var tabsLinkActiveLeftPosition = $('.tabs__link_active').position().left;
          var activeItemWidth = $('.tabs__link_active').width();
          var activeItemHeight = $('.tabs__link_active').position().top + 30;
          $('.tabs__line').css('width', activeItemWidth);
          if( window.innerWidth <= 767 ){
            $('.tabs__line').css('top', activeItemHeight);
          }
          else {
            $('.tabs__line').css('left', tabsLinkActiveLeftPosition);
          }

          document.dispatchEvent(_eventTabsShow);


        },
        _switchTabTo = function (tabsLinkIndex) {
          var tabsLinks = _elemTabs.querySelectorAll('.tabs__link');
          if (tabsLinks.length > 0) {
            if (tabsLinkIndex > tabsLinks.length) {
              tabsLinkIndex = tabsLinks.length;
            } else if (tabsLinkIndex < 1) {
              tabsLinkIndex = 1;
            }
            _showTab(tabsLinks[tabsLinkIndex - 1]);
          }
        };

      _eventTabsShow = new CustomEvent('tab.show', { detail: _elemTabs });

      _elemTabs.addEventListener('click', function (e) {
        var tabsLinkTarget = e.target;
        // завершаем выполнение функции, если кликнули не по ссылке
        if (!tabsLinkTarget.classList.contains('tabs__link')) {
          return;
        }
        // отменяем стандартное действие
        e.preventDefault();
        _showTab(tabsLinkTarget);
      });

      return {
        showTab: function (target) {
          _showTab(target);
        },
        switchTabTo: function (index) {
          _switchTabTo(index);
        },
      }

    };

    $tabs('.tabs');


  },



  // JavaScript to be fired on all pages, after page specific JS is fired
  finalize() {
  },
};

